import { ComponentWithSubheader } from 'dash/shared'
import { MembershipList } from './list'
import Icon from '@mui/icons-material/Domain'
import React from 'react'

export default class Membership {
  static List = () => <ComponentWithSubheader path={['User']} label="Memberships" component={MembershipList} />
  static Icon = Icon
}
